import { combineReducers, configureStore } from '@reduxjs/toolkit';
import SidebarState from './reducers/side/sidebarMenu.Slice';
import breadcrumbs from '../components/Breadcrumbs/reducer/breadcrumbSlice';
import filterTag from './reducers/filterTags/filterTag.Slice';
import product from '../pages/Products/reducer/productSlice';
import categories from '../pages/Categories/reducer/categorySlice';
import authReducer from './reducers/auth/authSlice';
import DeletePopup from './reducers/ProductDeletePopup/DeletePopup.slice'
import productDetails from '../pages/EditProduct/reducer/productDetailsSlice';
import categoryDetails from '../pages/EditCategory/reducer/categoryDetailsSlice';
import brandDetails from '../pages/EditBrand/reducer/brandDetailsSlice';
import brands from '../pages/Brands/reducer/brandSlice';
import user from '../pages/Users/reducer/userSlice';
import orders from '../pages/OrderManage/reducer/orderSlice';
import orderDetails from '../pages/OrderDetails/reducer/orderDetailsSlice'
import bannerDetails from '../pages/AddBanners/reducer/bannerSlice'; 
import OfferDetails from '../pages/Offers/reducer/offerSlice';
import TagsDetails from '../pages/Tags/reducer/TagsSlice';
import AdminData from '../pages/Admin/reducer/adminSlice';
import Articles from '../pages/Articles/reducer/articleSlice';



const rootReducer = combineReducers({
  product: product,
  order: orders,
  category: categories,
  brand: brands,
  orderDetail: orderDetails,
  productDetail: productDetails,
  categoryDetail: categoryDetails,
  brandDetail: brandDetails,
  auth: authReducer,
  admins: AdminData,
  user:  user,
  banner: bannerDetails,
  offers: OfferDetails,
  tags: TagsDetails,
  articles: Articles,
});

const store = configureStore({
  reducer: {
    SidebarState,
    breadcrumbs,
    filterTag,
    rootReducer,
    DeletePopup,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
